import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { ListsPage, SharedLists } from "../lists/lists-page.tsx";
import { loadLists } from "../lists/loaders.ts";
import { listsSearch, retainPropertyFilter } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { TasksPending } from "../tasks/pending.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  if (viewer === null) {
    return <NoAccessPage />;
  }
  return viewer.role === "vendor" ? <SharedLists /> : <ListsPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/lists/")({
  staticData: { hasPropertyContext: true },
  validateSearch: listsSearch,
  search: retainPropertyFilter(),
  loader: async ({ context }) => loadLists(context.data),
  pendingComponent: TasksPending,
  component: Page,
});
